<div class="modal-header bg-dark text-light">
    <h4 class="modal-title">
        <i class="mdi mdi-sitemap"></i> 공지사항
    </h4>
    <button type="button" class="close text-light" aria-label="Close" (click)="clickCancel()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <dtg-notice-list [listType]="DtgListType.list"></dtg-notice-list>
    <!-- <div class="table-responsive mt-3">
        <table class="table table-sm table-hover align-items-center mb-0">
            <thead>
                <tr>
                    <th>공지유형</th>
                    <th>제목</th>
                    <th>등록자</th>
                    <th>등록일시</th>
                </tr>
            </thead>
            <tbody>          
                <tr *ngFor="let item of listNotice" class="pointer"  (click)="clickNoticeDetailModal(item)">
                    <td>{{item.noticeType}}</td>        
                    <td class="text-truncate titleTd">{{item.title}}</td>
                    <td>{{item.createUser}}</td>
                    <td>{{item.createDt | filterDateTime:'yyyy-MM-dd HH:mm:ss'}}</td>
                </tr>
            </tbody>
        </table>        
    </div>
    <div class="mt-3">
        <list-paging
            [inputPagingInfo]="pagingInfo"
            (callbackClickPageNumber)="callbackClickPageNumber($event)"
            (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
    </div> -->
</div>
<div class="modal-footer">   
    <button type="button" class="btn btn-outline-secondary btn-sm"
        ngbAutofocus
        (click)="clickCancel()">
        <i class="far fa-times-circle fa-fw"></i>
        닫기
    </button>
</div>